import React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import  SFTypography  from "../../typography";
import { SFBetaIcon } from "../../icons";
import getStyled from "../../../hooks/getStyled";
import ListItem from "@mui/material/ListItem";

const { styled } = getStyled();

export const StyledFooterIcon = styled("div")(({ theme }) => ({
  // Default style overrides for the left menu icon
  width: 12,
  height: 12,
  color: theme.palette.grey400.main,
  display: "flex",
  marginRight: 4,
}));

export const StyledGridItem = styled("div")(({ theme }) => ({
  paddingLeft: 6,
  paddingRight: 10,
  justifyContent: "center",
  alignItems: "center",
  display: "grid",
  gridTemplateColumns: "auto 1fr",
}));

export const StyledFooterItem = styled(ListItem)(({ theme }) => ({
  "& .MuiButtonBase-root": {
    paddingTop: 10.5,
    paddingBottom: 10.5,
  },
  "& .MuiListItemButton-root": {
    "& .MuiSvgIcon-root": {
      width: 12,
      height: 12,
      color: theme.palette.grey400.main,
    },
    "&:hover": {
      backgroundColor: theme.palette.grey100.main,
      "& .MuiSvgIcon-root": {
        color: theme.palette.grey500.main,
      },
      "& .MuiTypography-root": {
        color: theme.palette.grey500.main,
      },
    },
    "&.Mui-selected": {
      backgroundColor: theme.palette.grey100.main,
      position: "relative",
      "&::before": {
        content: "\"\"",
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        width: "5px",
        backgroundColor: theme.palette.grey450.main,
      },
      "& .MuiSvgIcon-root": {
        color: theme.palette.grey500.main,
      },
      "& .MuiTypography-root": {
        color: theme.palette.grey500.main,
      },
    },
  },
}));


const FooterItem = ({
  label,
  selected,
  onClick,
  onMouseOver,
  icon,
  devOnly = false,
  ...props
}) => (
  <StyledFooterItem
    {...props}
    disablePadding
    onClick={onClick}
    onMouseOver={onMouseOver}
  >
    <ListItemButton selected={selected}>
      <StyledGridItem alignItems="center" spacing={1}>
        <StyledFooterIcon>{icon}</StyledFooterIcon>
        <SFTypography
          variant="tableListDescription"
          align="center"
        >
          {label}
        </SFTypography>
        {devOnly && <SFBetaIcon />}
      </StyledGridItem>
    </ListItemButton>
  </StyledFooterItem>
);


export default FooterItem;